<mat-dialog-content>
  <h2 class="dialog-title-no-padding" mat-dialog-title>{{ editingTemplate ? 'Edit special schedule' : 'Add special schedule' }}</h2>

  <p class="text-opacity-low">
    This schedule overrides the regular timetable on matching dates, without changing the route's
    existing date ranges.
  </p>

  <form [formGroup]="form">
    <mat-form-field appearance="outline" class="w-100 mb-2">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100 mb-2">
      <mat-label>Applies</mat-label>
      <mat-select formControlName="type">
        <mat-option *ngFor="let option of typeOptions" [value]="option.value">{{ option.label }}</mat-option>
      </mat-select>
    </mat-form-field>
    <p class="text-opacity-low hint-margin">{{ selectedTypeHint() }}</p>

    <mat-form-field *ngIf="isDayOfWeek" appearance="outline" class="w-100 mb-2">
      <mat-label>Weekday</mat-label>
      <mat-select formControlName="dayOfWeek">
        <mat-option *ngFor="let day of weekdayOptions" [value]="day">{{ day }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="!isDayOfWeek" appearance="outline" class="mb-2">
      <mat-label>Date</mat-label>
      <input matInput type="date" formControlName="date" />
    </mat-form-field>

    <div *ngIf="isRecurring" class="mb-2">
      <mat-checkbox formControlName="hasPeriod">Limit to a date range</mat-checkbox>
      <div *ngIf="form.value.hasPeriod" class="d-flex gap-2 mt-2">
        <mat-form-field appearance="outline">
          <mat-label>Active from</mat-label>
          <input matInput type="date" formControlName="dateFrom" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Active to</mat-label>
          <input matInput type="date" formControlName="dateTo" />
        </mat-form-field>
      </div>
    </div>

    <ng-container *ngIf="!editingTemplate">
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>Copy slots from</mat-label>
        <mat-select [(value)]="selectedDonorId" (selectionChange)="applyDonor($event.value)">
          <mat-option *ngFor="let donor of donorTemplates" [value]="donor.id">{{ donorLabel(donor) }}</mat-option>
        </mat-select>
      </mat-form-field>
      <p class="text-opacity-low hint-margin">
        Pick an existing schedule to copy its timeslots as a starting point, then edit them below.
      </p>
    </ng-container>

    <p *ngIf="error" class="error-text-color">{{ error }}</p>

    <div formArrayName="slots">
      <mat-card *ngFor="let slot of slots.controls; let i = index" [formGroupName]="i" class="mb-3">
        <mat-card-content>
          <div class="d-flex gap-2 align-items-start mb-2">
            <mat-form-field appearance="outline">
              <mat-label>Time</mat-label>
              <input matInput type="time" formControlName="time" />
            </mat-form-field>

            <button mat-icon-button color="warn" type="button" (click)="removeSlot(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>

          <div class="d-flex gap-4">
            <div class="flex-fill">
              <h5>Reserved Seats</h5>
              <div formArrayName="reservedSeats">
                <div *ngFor="let entry of getReservedSeats(i).controls; let j = index" [formGroupName]="j"
                  class="d-flex gap-2 mb-1 align-items-start">
                  <mat-form-field appearance="outline" class="flex-fill">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="name" />
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="form-field-width-100">
                    <mat-label>Count</mat-label>
                    <input matInput type="number" min="0" formControlName="count" />
                  </mat-form-field>
                  <button mat-icon-button color="warn" type="button" (click)="removeEntry(i, 'reservedSeats', j)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
              <button mat-stroked-button type="button" (click)="addEntry(i, 'reservedSeats')">
                <mat-icon>add</mat-icon> Add
              </button>
            </div>

            <div class="flex-fill">
              <h5>Start Offset</h5>
              <div formArrayName="startOffset">
                <div *ngFor="let entry of getStartOffset(i).controls; let j = index" [formGroupName]="j"
                  class="d-flex gap-2 mb-1 align-items-start">
                  <mat-form-field appearance="outline" class="flex-fill">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="name" />
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="form-field-width-100">
                    <mat-label>Count</mat-label>
                    <input matInput type="number" min="0" formControlName="count" />
                  </mat-form-field>
                  <button mat-icon-button color="warn" type="button" (click)="removeEntry(i, 'startOffset', j)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
              <button mat-stroked-button type="button" (click)="addEntry(i, 'startOffset')">
                <mat-icon>add</mat-icon> Add
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="d-flex justify-content-center mt-3">
      <button mat-mini-fab color="primary" type="button" (click)="addSlot()">
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" [disabled]="saving" (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" type="button" [disabled]="!form.valid || saving || slots.length === 0" (click)="save()">
    {{ saving ? 'Saving…' : (editingTemplate ? 'Save' : 'Create') }}
  </button>
</mat-dialog-actions>
